export default {"src":"/_next/static/media/facebook-icon.b96ec8ee.svg","height":512,"width":512};